import { Dates } from '../packages/dates';
import storage from '../components/DeviceStorage/DeviceStorage';
import channels from './data/channels';
import Device from './../devices/device';
import ActivesSingleton from './../components/Header/ActivesSingleton';
import Metadata from '../requests/apa/Metadata';
import Translator from '../requests/apa/Translator';
import * as playerConstant from './playerConstants';
import store from '../store';
import ChannelStreamUtil from './ChannelStreamUtil';
import DefaultToggleFunctions from './DefaultToggleFunctions';
import { HIDE_MODAL, AAF_MODAL_ERROR, MODAL_FILTERS_LIVE_CATEGORIES, MODAL_FILTERS_LIVE, MODAL_CALL_CENTER } from '../actions/modal';
import settings, { IPTV, OTT } from './../devices/all/settings';
import EpgPersistence from '../AAF/Nepg/EpgPersistence';
import GeneralTask from '../requests/tasks/claropagos/GeneralTask';
import RequestManager from '../requests/RequestManager';
import UtilsClaroPagos from '../utils/payway/claroPagos';
import LoadPtv from "../AAF/LoaderExp/LoadPtv";
import getAppConfig from "../config/appConfig";
import { isAndroidDevice } from '../AAFPersistenceManager/helpers/Utils';
import { AAFPLAYER_PLAY, INPUT_STYLE_OUTFOCUS, QATAR2022ENABLED, KEYQATAR2022DEFAULT, SUPPORTEDSTREAMTYPE, DEFAULT, LIVE, REGION } from '../AAFPlayer/constants';
import AAFData from './AAFData';
import AnalyticsDimensionSingleton from '../components/Header/AnalyticsDimensionSingleton';
import { MUNDIAL2022 } from 'src/AAFPlayer/constants.js';
import packageJson from '../../package.json';
import {
  CONTENT_AVAILABILITY_FREE, CONTENT_AVAILABILITY_SUBSCRIPTION, CONTENT_AVAILABILITY_RENT, CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION,
  CONTENT_AVAILABILITY_BUY_EPISODE, CONTENT_AVAILABILITY_BUY_SEASON, CONTENT_AVAILABILITY_BUY,
  CONTENT_TYPE_MOVIE, CONTENT_TYPE_SERIE, CONTENT_TYPE_DOCUMENTARY, CONTENT_TYPE_TV,
  DOES_NOT_APPLY
} from 'src/utils/trackers/GA4Constants';
import device from "../../src/devices/device";
import {
  CHARACTERS_BUTTON_CONTRATA,
  CHARACTERS_BUTTON_INCLUDES,
  CHARACTERS_LABEL_PROMOTION,
  CHARACTERS_LABEL_TASK,
  CHARACTERS_LABEL_PERIODICITY,
  CHARACTERS_LABEL_PRICE,
  BUTTON_CONTRATA,
  BUTTON_INCLUDES,
  LABEL_PROMOTION,
  LABEL_TASK,
  LABEL_PERIODICITY,
  LABEL_PRICE
} from 'src/packages/components/lib/PlanSelector/constants';
import { isLoggedIn, queryUserSync } from '../requests/loader';

class Utils {

  static cutPlayerString(str, maxLong, maxBeforeDots = null, dots = '...') {
    if (!str) return str;
    if (isNaN(maxLong)) return str;
    if (maxLong < 0) return;

    str = str + '';
    str = str.trim();

    if (str.length > maxLong) {
      if (!maxBeforeDots) {
        maxBeforeDots = maxLong - 2;
        if (maxBeforeDots < 1) maxBeforeDots = maxLong;
      }

      str = str.substring(0, maxBeforeDots);
      str = str + dots;
    }
    return str;
  }

  static cutFinPlayerString(str, maxLong = str.length, maxBeforeDots = null, dots = '...') {
    if (!str) return str;
    if (isNaN(maxLong)) return str;
    if (maxLong < 0) return;

    str = str + '';
    str = str.trim();

    if (str.length > maxLong) {
      str = str.substring(0, maxBeforeDots);
      str = str.trim() + dots;
    }
    return str;
  }

  static cutInTwoLines(string, maxCharsByLine) {
    let cutFirstLine;
    const firstLine = string.slice(0, maxCharsByLine);
    if (firstLine[maxCharsByLine - 1] === " " || firstLine[maxCharsByLine] === " ") {
      cutFirstLine = false;
    } else {
      cutFirstLine = true;
    }

    if (cutFirstLine) {
      const newFirstLine = this.dropLastWord(firstLine);
      const firstLineLength = newFirstLine.length + 1;
      return this.cutPlayerString(string, firstLineLength + maxCharsByLine);
    } else {
      return this.cutPlayerString(string, maxCharsByLine * 2);
    }
  }

  static dropLastWord(line) {
    const split = line.split(" ")
    return split.slice(0, split.length - 1).join(" ");
  }

  static getAudioLangByGroupId(gid) {
    return ChannelStreamUtil.get(gid);
  }

  static getMisContenidosNode() {
    return Utils.getApaMetadataKey('links_nav_configuration', '{}', 'miscontenidos');
  }

  static getLinks() {
    return Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
  }

  static isCurrentNode(node = '', history = {}) {
    let isCurrent = false;
    if (Utils.getLinks()) {
      const nodes = Utils.getLinks();
      const currentNode = nodes && (nodes[node] || `/node/${nodes[node]}`);
      isCurrent = history.location.pathname.includes(currentNode) || false;
    }
    console.log(":::isCurrent", isCurrent, node);
    return isCurrent;
  }

  static getForceNoHeaderBlueBand() {
    //Esta llave esta apagada por default
    return Utils.getApaMetadataKey('force_no_header_blue_band', '{"enable":false}', 'enable');
  }

  static setHKS(user) {
    const platform = Device.getDevice().getPlatform();
    const isAndroid = platform === "android";
    try {
      if (isAndroid && window.AndroidPlayerInterface) {
        window.AndroidPlayerInterface.saveIsLoggedIn(JSON.stringify(user));
      }
    } catch (err) {
      console.log("[ERROR]-saveIsLoggedIn", err);
    }

    if (user && user.response && user.response.session_stringvalue) {
      storage.setItem("HKS", user.response.session_stringvalue);
    }
  }

  static setHKSTermsAndConditions(user) {
    const userData = JSON.stringify({
      response: user.response.userData,
    });
    const platform = Device.getDevice().getPlatform();
    const isAndroid = platform === "android";
    try {
      if (isAndroid && window.AndroidPlayerInterface) {
        window.AndroidPlayerInterface.saveIsLoggedIn(JSON.stringify(userData));
      }
    } catch (err) {
      console.log("[ERROR]-saveIsLoggedIn", err);
    }

    if (userData) {
      storage.setItem("HKS", user.response.userData.session_stringvalue);
    }
  }

  static sleep(seconds) {
    return new Promise((resolve) => setTimeout(resolve, seconds * 1000));
  }

  static isHtmlElement(element = null) {
    if (element === null) {
      return false;
    }
    return element instanceof Element;
  }

  static isInteger(element = null) {
    if (element === null) {
      return false;
    }
    return Number.isInteger(element);
  }

  static isNull(obj) {
    return obj === null;
  }

  static isNullOrUndefined(obj) {
    return Utils.isNull(obj) || Utils.isUndefined(obj);
  }

  static isNotNullOrNotUndefined(obj) {
    return !Utils.isNullOrUndefined(obj);
  }

  static isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  }

  static isUndefined(obj) {
    return typeof obj === "undefined";
  }

  static isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
  }

  static isFunction(obj) {
    return Object.prototype.toString.call(obj) === "[object Function]";
  }

  static isObject(obj) {
    return obj === Object(obj);
  }

  static isBoolean(obj) {
    return Object.prototype.toString.call(obj) === "[object Boolean]";
  }

  static isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  static urlParamsToJson(string) {
    let newObj = null;
    // Y si la url no trae params?
    if (string.indexOf("?") !== -1) {
      newObj = {};
      let urlParams = string.split("?")[1];
      urlParams = urlParams.split("&").reduce(function (prev, curr, i, arr) {
        var p = curr.split("=");
        prev[decodeURIComponent(p[0])] = decodeURIComponent(p[1]);
        return prev;
      }, {});

      for (const option in urlParams) {
        newObj[option] = urlParams[option];
      }
    }

    return newObj;
  }

  static appendParamToUrl(url, paramName, paramValue) {
    if (Utils.contains(url, "?")) {
      return url + "&" + paramName + "=" + paramValue;
    }
    return url + "?" + paramName + "=" + paramValue;
  }

  static contains(str, str2) {
    return str.indexOf(str2) !== -1;
  }

  static b64EncodeUnicode(str) {
    return btoa(
      encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode("0x" + p1);
      })
    );
  }

  static b64DecodeUnicode(str) {
    return decodeURIComponent(
      Array.prototype.map
        .call(atob(str), function (c) {
          return "%" + c.charCodeAt(0).toString(16);
        })
        .join("")
    );
  }

  static base64_encode(stringToEncode) {
    // eslint-disable-line camelcase
    //  discuss at: http://locutus.io/php/base64_encode/
    // original by: Tyler Akins (http://rumkin.com)
    // improved by: Bayron Guevara
    // improved by: Thunder.m
    // improved by: Kevin van Zonneveld (http://kvz.io)
    // improved by: Kevin van Zonneveld (http://kvz.io)
    // improved by: Rafał Kukawski (http://blog.kukawski.pl)
    // bugfixed by: Pellentesque Malesuada
    // improved by: Indigo744
    //   example 1: base64_encode('Kevin van Zonneveld')
    //   returns 1: 'S2V2aW4gdmFuIFpvbm5ldmVsZA=='
    //   example 2: base64_encode('a')
    //   returns 2: 'YQ=='
    //   example 3: base64_encode('✓ à la mode')
    //   returns 3: '4pyTIMOgIGxhIG1vZGU='
    // encodeUTF8string()
    // Internal function to encode properly UTF8 string
    // Adapted from Solution #1 at https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
    const encodeUTF8string = function (str) {
      // first we use encodeURIComponent to get percent-encoded UTF-8,
      // then we convert the percent encodings into raw bytes which
      // can be fed into the base64 encoding algorithm.
      return encodeURIComponent(str).replace(
        /%([0-9A-F]{2})/g,
        function toSolidBytes(match, p1) {
          return String.fromCharCode("0x" + p1);
        }
      );
    };
    if (typeof window !== "undefined") {
      if (typeof window.btoa !== "undefined") {
        return window.btoa(encodeUTF8string(stringToEncode));
      }
    } else {
      return new Buffer(stringToEncode).toString("base64");
    }
    const b64 =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let o1;
    let o2;
    let o3;
    let h1;
    let h2;
    let h3;
    let h4;
    let bits;
    let i = 0;
    let ac = 0;
    let enc = "";
    let tmpArr = [];
    if (!stringToEncode) {
      return stringToEncode;
    }
    stringToEncode = encodeUTF8string(stringToEncode);
    do {
      // pack three octets into four hexets
      o1 = stringToEncode.charCodeAt(i++);
      o2 = stringToEncode.charCodeAt(i++);
      o3 = stringToEncode.charCodeAt(i++);
      bits = (o1 << 16) | (o2 << 8) | o3;
      h1 = (bits >> 18) & 0x3f;
      h2 = (bits >> 12) & 0x3f;
      h3 = (bits >> 6) & 0x3f;
      h4 = bits & 0x3f;
      // use hexets to index into b64, and append result to encoded string
      tmpArr[ac++] =
        b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < stringToEncode.length);
    enc = tmpArr.join("");
    const r = stringToEncode.length % 3;

    return (r ? enc.slice(0, r - 3) : enc) + "===".slice(r || 3);
  }

  static Base64Decode(str) {
    return window.atob(str);
  }

  static setBackgroundImage(image_background) {
    if (image_background && image_background !== "") {
      this.idTimeout = setTimeout(() => {
        document.getElementById("root").classList.add("bgimage");
        document.getElementById("root").style.backgroundImage =
          "url('" + image_background + "')";
        const header = document.getElementsByClassName("header");
        if (header.length > 0) {
          header[0].classList.add("black");
        }
      }, 1000);
    } else {
      this.idTimeout = setTimeout(() => {
        document.getElementById("root").classList.remove("bgimage");
        document.getElementById("root").style.backgroundImage = "";
      }, 1000);
    }
  }

  static setBackgroundImageWithoutDelay(image_background) {
    if (image_background && image_background !== "") {
      document.getElementById("root").classList.add("bgimage");
      document.getElementById("root").style.backgroundImage =
        "url('" + image_background + "')";
      const header = document.getElementsByClassName("header");
      if (header.length > 0) {
        header[0].classList.add("black");
      }
    } else {
      document.getElementById("root").classList.remove("bgimage");
      document.getElementById("root").style.backgroundImage = "";
    }
  }

  static resetBackground() {
    document.getElementById("root").classList.remove("bgimage");
    document.getElementById("root").style.backgroundImage = "";
  }

  static htmlEncode(value) {
    return "";
  }

  static htmlDecode(str) {
    var element = document.createElement("div");
    if (str && typeof str === "string") {
      // Escape HTML before decoding for HTML Entities
      str = escape(str)
        .replace(/%26/g, "&")
        .replace(/%23/g, "#")
        .replace(/%3B/g, ";");
      element.innerHTML = str;
      if (element.innerText) {
        str = element.innerText;
        element.innerText = "";
      } else {
        // Firefox support
        str = element.textContent;
        element.textContent = "";
      }
    }
    return unescape(str);
  }

  static getInnerText(strHtml) {
    var div = document.createElement("div");
    div.innerHTML = strHtml;
    var text = div.textContent || div.innerText || "";
    return text;
  }
  /**
   * Apartir de una url esta funcion la descompone en uri y un objeto con parametros
   *
   * @param {string} qs
   */
  static getRequest(qs) {

    const result = {
      params: {},
      uri: ''
    };

    if (qs === undefined) {
      return result;
    }

    const qsArray = qs.split("?");

    if (qsArray[0]) {
      result.uri = qsArray[0];
    }

    if (qsArray[1]) {
      result.params = this.getAllParametersFromQs(qsArray[1]);
    }

    return result;
  }

  /**
   * regresa un objeto Json con los parametros de un querystring
   * @param {string} qs
   */
  static getAllParametersFromQs(qs) {
    let res;
    let params = {};

    if (qs) {
      res = qs.split("&");
      res.forEach((item, index) => {
        const par = item.split("=");
        if (par[0] && par[1]) {
          params[par[0]] = decodeURIComponent(par[1]);
        }
      });
    }

    return params;
  }

  static isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  /*Load external js scripts or specific js scripts by platform*/
  static loadScript(url) {
    if (Utils.isArray(url)) {
      let prom = [];
      url.forEach((item) => {
        prom.push(Utils.loadScript(item));
      });

      return Promise.all(prom);
    }

    return new Promise(function (resolve, reject) {
      console.log("[Utils] loadScript" + url);

      let pageScripts = document.getElementsByTagName("script")[0];
      let newScript = document.createElement("script");

      newScript.type = "text/javascript";
      newScript.src = url;

      newScript.onload = () => {
        resolve();
      };
      newScript.onerror = newScript.onabort = reject;
      pageScripts.parentNode.insertBefore(newScript, pageScripts);
    });
  }

  /**
   * regresa un string con los parámetros de un objeto en formato queryString
   * @param {object} data
   */
  static buildQueryParams(data = {}) {
    if (typeof data === "object") {
      return Object.keys(data)
        .reduce((queryParams, k) => {
          if (data[k] !== undefined && data[k] !== null && data[k] !== "") {
            queryParams.push(k + "=" + data[k]);
          }
          return queryParams;
        }, [])
        .join("&");
    }
    return "";
  }

  /**
   * válida un string con el formato correcto de un email
   * @param {string} email
   */
  static isValidEmail(email = "") {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
  }

  /**
   * Convierte un string con formato YYYY/MM/DD hh:mm:ss en Formato Unix Epoch UTC 64 bits para usar timeshift
   * @param {string} stringDate
   */
  static getClaroUnixEpochTime(stringDate) {
    /*const date = new Date(stringDate);
     const epoch = date.getTime() / 1000.0;
     const result = `${Math.round(epoch)}`;
     */
    //return '15126610420000000'; // TIMESHIFTTESTING
    stringDate = `${stringDate}`;
    return stringDate.length === 10 ? `${stringDate}0000000` : stringDate;
  }

  /**
   * Obtiene el canal más cercano a un canal no existente
   * @param int searchedChannel
   * @param Array channels
   */
  static getClosestChannel(searchedChannel, channels) {
    const channelsBefore = channels.filter(
      (channel) => parseInt(channel.id) < searchedChannel
    );
    const channelAfter = channels.find(
      (channel) => parseInt(channel.id) > searchedChannel
    );
    const channelBefore =
      channelsBefore.length > 0
        ? channelsBefore[channelsBefore.length - 1]
        : null;

    if (!channelBefore) {
      return channelAfter;
    } else if (!channelAfter) {
      return channelBefore;
    } else {
      const diffBefore = searchedChannel - parseInt(channelBefore.id);
      const diffAfter = parseInt(channelAfter.id) - searchedChannel;
      if (diffBefore < diffAfter) {
        return channelBefore;
      } else {
        return channelAfter;
      }
    }
  }

  /**
   * Formatea una cantidad de segundos en hs mins
   */
  static parseSecondsToHours(totalSeconds) {
    const secondsInHour = 3600;
    const secondsInMinute = 60;

    const hours = totalSeconds / secondsInHour;
    const seconds = totalSeconds % secondsInHour;

    const hoursParsed = seconds === 0 ? hours : Math.floor(hours);
    const minutesParsed =
      seconds === 0 ? 0 : Math.floor(seconds / secondsInMinute);

    return `${hoursParsed}hs ${minutesParsed}mins.`;
  }

  static formatDatesWithOffset(dates, formatToken) {
    return EpgPersistence.needsOffset() ?
      dates.utcOffset(EpgPersistence.needsOffset(), false).format(formatToken) :
      dates.format(formatToken);
  }

  /**
   * Obtiene un Date con la hora correcta actual
   */

  static now(asMoment = false, unit = "seconds") {
    // const server = parseInt(storage.getItem('server_time').substring(0,10));
    // const init = parseInt(storage.getItem('local_time').substring(0,10));
    const server = storage.getItem("server_time");
    const init = storage.getItem("local_time");
    const regex = RegExp("^[0-9]{10}[0-9]*$", "g");
    let momentoServer;
    if (regex.test(server)) {
      momentoServer = new Dates().unix(server.substring(0, 10));
    } else {
      momentoServer = new Dates(server);
    }

    return asMoment
      ? momentoServer.add(new Dates().diff(init, unit), unit)
      : momentoServer.add(new Dates().diff(init, unit), unit).toDate();
  }

  static nowAsTimestampSeconds() {
    const _now = Utils.now(true);
    return _now.unix();
  }

  static convertUnixOrFormattedDateToDatesObject(date) {
    if (!isNaN(date)) {
      //date is unix
      return EpgPersistence.needsOffset()
        ? new Dates().unix(date).utcOffset(EpgPersistence.needsOffset(), false)
        : new Dates().unix(date);
    }
    else {
      return EpgPersistence.needsOffset()
        ? new Dates(date).utcOffset(EpgPersistence.needsOffset(), true)
        : new Dates(date);
    }
  }

  /**
   * Evalúa si un Date se encuentra dentro de dos fechas con la hora calculada del servidor
   * @param {string} dateBegin
   * @param {string} dateEnd
   */
  static isDateBetween(
    dateBegin = "YYYY/MM/DD hh:mm:ss",
    dateEnd = "YYYY/MM/DD hh:mm:ss"
  ) {
    if (!dateBegin || !dateEnd)
      return false;
    const now = this.now(true).unix();
    let start = null,
      end = null;
    if (!isNaN(dateBegin)) {
      start = dateBegin;
    } else {
      start = EpgPersistence.needsOffset()
        ? new Dates(dateBegin).utcOffset(EpgPersistence.needsOffset(), true).unix()
        : new Dates(dateBegin).unix();
    }
    if (!isNaN(dateEnd)) {
      end = dateEnd;
    } else {
      end = EpgPersistence.needsOffset()
        ? new Dates(dateEnd).utcOffset(EpgPersistence.needsOffset(), true).unix()
        : new Dates(dateEnd).unix();
    }
    return start <= now && now <= end;
  }

  /**
   * formatea la duración de un contenido para mostrar en el resumen
   * @param {string} duration
   */
  static formatDuration(duration = '00:00:00') {
    let [hours, minutes, seconds] = duration.split(':')
    hours = parseInt(hours);
    minutes = parseInt(minutes);
    seconds = parseInt(seconds);
    return hours !== 0
      ? `${hours} h ${minutes !== 0 ? minutes + ' min' : ''}`
      : `${minutes} min`;
  }

  static mock_links_nav_configuration() {
    const mock = {
      music: "claromusica",
      ppv: "nagrappe",
      clarotv: new ActivesSingleton().getTvNode(),
      home: "homeuser"
    };

    return JSON.stringify(mock);
  }

  static getChannelUrl(group_id) {
    return channels[group_id] ? channels[group_id] : null;
  }
  static isMiniEpgPersistanceOpen() {
    const element = document.getElementById("mini-container");
    if (
      element &&
      element.style &&
      element.style.visibility &&
      element.style.visibility === "visible"
    ) {
      return true;
    }
    return false
  }


  static isFullEpgOpen() {
    const epgFullElement = this.getClassByClass("full-epg", "epg-main");
    if (epgFullElement.length > 0) {
      return true;
    }
    if (settings.enable_epg_syc) {
      return this.isFullEpgPersistanceOpen();
    }
    return false;
  }
  static MiniEpgPersistanceOpen() {
    let element = null;
    let result = false;
    //nueva experiencia
    element = document.getElementById("mini-container");
    if (
      element &&
      element.style &&
      element.style.display &&
      element.style.display === "block"
    ) {
      result = true;
    }
    // vieja experiencia
    // const elemet = document.getElementById("player-ui-container");
    // let result =
    //   elemet &&
    //   elemet.className &&
    //   elemet.className.indexOf("show-mini-epg") !== -1 &&
    //   elemet.className.indexOf("hide-controls") === -1;
    // if (result) {
    //   result = true;
    // }
    return result;
  }

  static isFullEpgPersistanceOpen() {
    const epgFullElement = this.getClassByClass(
      "full-epg",
      "FullEpgPersistanceWrapper"
    );
    if (epgFullElement.length > 0) {
      return true;
    }
    return false;
  }

  static isFullEpgMosaicOpen() {
    const epgFullMosaic = this.getClassByClass("full-epg", "channels-wrapper");
    if (epgFullMosaic.length > 0) {
      return true;
    }
    return false;
  }

  static miniFullEpgAutoHideSeconds(from = "", time = 0) {
    try {
      const _region = storage.getItem("region");
      //Dejando el valor actual en time para el default
      const defaultValue = '{"default":{"time":' + time + "}}";
      let tmp = time;
      const meta = Metadata.get(from, defaultValue);
      const objectMeta = JSON.parse(meta);
      const value = objectMeta[_region]
        ? objectMeta[_region]
        : objectMeta["default"];
      if (value && typeof value === "object" && value.hasOwnProperty("time")) {
        tmp = value.time;
      }
      return tmp;
    } catch (e) {
      // valor por default que tenia en el código ==>time
      return time;
    }
  }

  static getClassByClass(father, child) {
    const element = document.getElementsByClassName(father);
    let arr = Array.from(element);
    const children = arr.length > 0 ? arr[0].getElementsByClassName(child) : [];
    return children;
  }

  static getClassById(father, child) {
    const element = document.getElementById(father);
    const children = element.getElementsByClassName(child);
    const arr = Array.from(children);
    return arr && arr[0];
  }

  static isMiniEPGOpen() {
    const elemet = document.getElementById("player-ui-container");
    const isOpen =
      elemet &&
      elemet.className &&
      elemet.className.indexOf("hide-controls") === -1;
    return isOpen;
  }

  static isActionBarOpen() {
    const qsaActionBar = document.querySelectorAll("div.action-bar.container");
    const qsaActionBarHide = document.querySelectorAll("div.action-bar.hide");
    return qsaActionBar.length > 0 && qsaActionBarHide.length === 0;
  }

  static isLineTime() {
    var lineTime = window.document.getElementById("line-time");
    if (lineTime) return true;
    return false;
  }

  static isCurrentEventFuture(current) {
    const { event } = current;
    let dateBegin = event.date_begin;
    let isFutureEvent = this.isDateBetween(Utils.now(true).unix(), dateBegin);
    return isFutureEvent;
  }

  static getEpgRange(
    indexChannel,
    totalChannels,
    verticalOffset,
    visibleRows,
  ) {
    let from;
    let quantity;
    let infinite_fix;
    let diff = 0;
    quantity = visibleRows + verticalOffset * 2;
    if (Device.getDevice().getConfig().useEpgPostals) {
      if (totalChannels <= quantity) {
        from = indexChannel;
        infinite_fix =
          from + quantity > totalChannels
            ? from + quantity - totalChannels
            : "";
      } else {
        diff = indexChannel - verticalOffset;
        if (diff < 0) {
          from = totalChannels - Math.abs(diff);
          infinite_fix = quantity - Math.abs(diff);
        } else {
          from = diff;
          infinite_fix =
            from + quantity > totalChannels
              ? from + quantity - totalChannels
              : "";
        }
      }
    } else {
      const safetyArea = visibleRows + verticalOffset;
      infinite_fix = "";

      if (totalChannels <= safetyArea) {
        from = indexChannel;
        quantity = totalChannels - from;
        diff = totalChannels - quantity;
        infinite_fix = diff;
      } else {
        diff = indexChannel - verticalOffset;
        if (diff < 0) {
          from = totalChannels - Math.abs(diff);
          quantity = totalChannels - from;
          infinite_fix = safetyArea + verticalOffset - quantity;
          if (quantity + infinite_fix >= totalChannels) {
            infinite_fix -= Math.abs(quantity + infinite_fix - totalChannels);
          }
        } else {
          from = diff;
          quantity = safetyArea + verticalOffset;
          if (from + safetyArea + verticalOffset > totalChannels) {
            quantity =
              from + safetyArea + verticalOffset >= totalChannels
                ? totalChannels - from
                : safetyArea + verticalOffset;
            infinite_fix = visibleRows + verticalOffset * 2 - quantity;
          }
          /*infinite_fix = totalChannels - quantity;*/
        }
      }
    }
    infinite_fix = infinite_fix || 0;
    return {
      from,
      quantity,
      infinite_fix,
    };
  }

  static getAbbreviation(country) {
    const abbreviations = {
      chile: "CL",
      mexico: "MX",
      colombia: "CO",
      peru: "PE",
      brasil: "BR",
      argentina: "AR",
      dominicana: "DO",
      guatemala: "GT",
      ecuador: "EC",
      elsalvador: "SV",
      paraguay: "PY",
      nicaragua: "NI",
      costarica: "CR",
      uruguay: "UY",
      honduras: "HN",
      panama: "PA",
      puertorico: "PR",
    };
    return abbreviations[country] || null;
  }

  static getFieldFromJsonToArray(data, field) {
    if (!data) {
      return [];
    }

    return data.map((x, index) => {
      return x[field];
    });
  }

  /**
   * Returns a hash code for a string.
   * (Compatible to Java's String.hashCode())
   *
   * The hash code for a string object is computed as
   *     s[0]*31^(n-1) + s[1]*31^(n-2) + ... + s[n-1]
   * using number arithmetic, where s[i] is the i th character
   * of the given string, n is the length of the string,
   * and ^ indicates exponentiation.
   * (The hash value of the empty string is zero.)
   *
   * @param {string} s a string
   * @return {number} a hash code value for the given string.
   */
  static hashCode(s) {
    let h = 0,
      l = s.length,
      i = 0;
    if (l > 0) while (i < l) h = ((h << 5) - h + s.charCodeAt(i++)) | 0;
    return h;
  }

  /* INIT - ONLY FOR DEBUG */
  static setMarkTime(replace, msg) {
    if (replace) {
      storage.setItem("DEBUG_marktime", new Date().getTime());
      console.log(
        "[MARKTIME] ------------------------------------> setting first mark time"
      );
    } else {
      const lastMark = storage.getItem("DEBUG_marktime");
      if (lastMark) {
        const currentTime = new Date().getTime();
        if (currentTime >= lastMark) {
          const diff = (currentTime - lastMark) / 1000;
          if (msg) {
            console.log(
              "[MARKTIME] ------------------------------------> time between: " +
              diff +
              " seconds" +
              " [" +
              msg +
              "]"
            );
          } else {
            console.log(
              "[MARKTIME] ------------------------------------> time between: " +
              diff
            );
          }
          // Update local storage
          storage.setItem("DEBUG_marktime", currentTime);
        }
      }
    }
  }
  /* END - ONLY FOR DEBUG */
  static streamIsVideo(streamType) {
    const videoStreams = [
      playerConstant.WVC,
      playerConstant.SS,
      playerConstant.SS_MA,
      playerConstant.HLS,
      playerConstant.HLS_KR,
      playerConstant.HLSPRM,
      playerConstant.DVBC,
      playerConstant.DVBS,
      playerConstant.IP_MULTICAST,
      playerConstant.IP_MULTICAST_UDP,
      playerConstant.IP_MULTICAST_LMS,
      playerConstant.DASHWV,
      playerConstant.DASHWV_MA,
    ];

    return videoStreams.find((availableStreamType) => {
      return availableStreamType === streamType;
    });
  }

  static streamIsAudio(streamType) {
    const audioStreams = [playerConstant.AUDIO, playerConstant.RADIO];

    return audioStreams.find((availableStreamType) => {
      return availableStreamType === streamType;
    });
  }

  static parseData(response) {
    return response.map((it) => {
      it.data = JSON.parse(it.data);
      return it;
    });
  }

  static streamIsSpot(streamType) {
    const spotStreams = [playerConstant.SPOT];

    return spotStreams.find((availableStreamType) => {
      return availableStreamType === streamType;
    });
  }

  static getRegionaliazedMetadata(key, defaultValue = "{}") {
    //Country is not required because comes from localstorage
    const region = storage.getItem("region") || "default";
    let procesando = Metadata.get(key, defaultValue);

    if (!procesando || procesando === "{}") return {};
    try {
      procesando = JSON.parse(procesando);
    } catch (e) {
      console.log("Unable to process Regionaliazed Metadata" + key, e);
      return {};
    }
    if (procesando[region] || procesando["default"]) {
      return procesando[region] || procesando["default"];
    }
    return {};
  }

  static getExternalProviderOffers(provider, paywayData) {
    const lowerProvider = provider.toLowerCase();
    return paywayData
      .filter((d) => d.producttype.toLowerCase() === lowerProvider)
      .map((d) => d.offer_id);
  }

  static deviceCanPlayProvider(provider, config = {}) {
    let deviceConfig = Device.getDevice().getConfig();
    if (
      deviceConfig.supported_stream_types &&
      deviceConfig.supported_stream_types.vod
    ) {
      if (
        deviceConfig.supported_stream_types.vod &&
        deviceConfig.supported_stream_types.live
      ) {
        deviceConfig = deviceConfig.supported_stream_types.vod.concat(
          deviceConfig.supported_stream_types.live
        );
      } else {
        deviceConfig = deviceConfig.supported_stream_types.vod;
      }
    } else {
      deviceConfig = null;
    }

    const { encodes } = config.subscrition[provider] || { encodes: [] };

    if (!encodes || !encodes.length) return true;

    if (deviceConfig === null) {
      return true;
    }

    const posibles = deviceConfig;

    return posibles.some((p) => encodes.indexOf(p) > -1);
  }

  static isModalHide() {
    const state = store.getState();
    return (
      state.modal.modalType === null || state.modal.modalType === HIDE_MODAL
    );
  }

  static isNotificationHide() {
    const state = store.getState();
    if (state.notification && state.notification.notificationProps) {
      return !state.notification.notificationProps.show
    }
    return true;
  }

  static modalType() {
    const state = store.getState();
    console.log("[dann] modaltype", state.modal);
    return state.modal.modalType;
  }
  static modalFrom() {
    const state = store.getState();
    if (
      state &&
      state.modal &&
      state.modal.modalProps &&
      state.modal.modalProps.from
    )
      return state.modal.modalProps.from;
    else return null;
  }

  static isModalCallCenterOpen() {
    return this.modalType() === MODAL_CALL_CENTER;
  }

  static isVisibleAlertHeaderBelt() {
    const state = store.getState();
    console.log("[angeel] status de alerta header:", state.flagAlertBelt);

    return state.flagAlertBelt.activeBelt;
  }

  /**
   * Para testing de sony, NO android con opera browser
   * User-agent: Opera/9.80 (Linux armv7l) Presto/2.12.407 Version/12.50 SonyCEBrowser/1.0 (DTV13/KDL-40W600B; CTV/PKG3.004AAA; MEX; es;)
   */
  static isSonyBraviaOperaBrowser() {
    const agent = navigator.userAgent.toLowerCase();
    const platf = Device.getDevice().getPlatform();
    if (agent.indexOf("presto") !== -1 && platf === "sony") {
      return true;
    } else {
      return false;
    }
  }

  static deviceSupportHttps() {
    if (
      this.isSonyBraviaOperaBrowser() ||
      this.isSamsungOrsay() ||
      this.isNetcast()
    ) {
      return false;
    } else {
      return true;
    }
  }

  static numberEpisodesCardRecordings(numEpisodios = 0) {
    return (numEpisodios ? numEpisodios + ' ' + Translator.get('content_data_episodes_label', 'episodios') : '');
  }

  static isHttpsProtocol() {
    return window.location.protocol === 'https:';
  }

  static isSamsungOrsay() {
    return Device.getDevice().getPlatform() === "samsung";
  }

  static isNetcast() {
    return Device.getDevice().getPlatform() === "lg";
  }

  static isWeb0s() {
    return Device.getDevice().getPlatform() === "web0s";
  }

  static isHisense() {
    return Device.getDevice().getPlatform() === "hisense";
  }

  static isSonyAndroid() {
    return Device.getDevice().getPlatform() === "sony" && !this.isSonyBraviaOperaBrowser();
  }

  static isWorkstation() {
    return Device.getDevice().getPlatform() === "workstation";
  }

  static isPlaystation4() {
    return Device.getDevice().getPlatform() === "ps4";
  }

  static isAndroidTV() {
    return Device.getDevice().getPlatform() === "androidtv";
  }

  static isSTBZTE() {
    const subPlatform = Object.prototype.toString.call(Device.getDevice().getSubplatform) === "[object Function]" ? Device.getDevice().getSubplatform() : '';
    return subPlatform === 'zte';
  }

  static isSTBCoship() {
    let subplatform = '';
    if (typeof Device.getDevice().getSubplatform === 'function') {
      subplatform = Device.getDevice().getSubplatform();
    }

    return subplatform === 'stbcoship';
  }

  static isSTBKaon() {
    let subplatform = '';
    if (typeof Device.getDevice().getSubplatform === 'function') {
      subplatform = Device.getDevice().getSubplatform();
    }

    return subplatform === 'stbkaon';
  }

  static isSeirobotics() {

    const SEIROBOTICS = 'seirobotics';
    const platform = Device.getDevice().getPlatform();
    let subplatform = '';

    if (platform === 'android') {
      if (typeof Device.getDevice().getSubplatform === 'function') {
        subplatform = Device.getDevice().getSubplatform();
      }
    }

    return subplatform === SEIROBOTICS;

  }

  static deviceIsNotHisense() {
    const agent = navigator.userAgent.toLowerCase();
    return Device.getDevice().getPlatform() === "hisense"
      ? agent.indexOf("hisense/2014") !== -1 || agent.indexOf("5651") !== -1
        ? true
        : false
      : true;
  }

  static mapRibbonToMusic(ArrayItems) {
    let result = [];
    if (ArrayItems && Array.isArray(ArrayItems)) {
      result = ArrayItems.map((item) => {
        return {
          id: item.entity_id || null,
          title: item.title || " ",
          image: item.img || null,
          author: " ",
          type: " ",
          isFollowing: false,
          followers: " ",
          tracks: item.tracks || null,
          duration: item.duration || "",
          kind: "playlist",
        };
      });
    }
    return result;
  }

  static getAPAFilterList() {
    let filters = Metadata.get("byr_filterlist_configuration");

    try {
      filters = JSON.parse(filters);

      if (filters && filters.filterlist) {
        return filters.filterlist;
      }
    } catch (e) {
      return null;
    }

    return null;
  }

  static combineLiveStreamType(ApaStreams, groupIdStreams) {
    let streamOptions = [];
    for (let i = 0; i < ApaStreams.length; i++) {
      if (groupIdStreams.indexOf(ApaStreams[i]) !== -1) {
        streamOptions.push(ApaStreams[i]);
      }
    }

    return streamOptions;
  }

  static getChannelInfo(gid) {
    return ChannelStreamUtil.get(gid);
  }

  static setLiveURLFromFastPlay(gid, streams) {
    let channelInfo = ChannelStreamUtil.get(gid);
    // Si ya esta cacheado, no hace nada
    if (channelInfo && channelInfo.updated_live_url) {
      return;
    }
    if (channelInfo && channelInfo.fast_play) {
      for (let i = 0; i < streams.length; i++) {
        if (Object.keys(channelInfo.fast_play).indexOf(streams[i]) !== -1) {
          if (Utils.isObject(channelInfo.fastPlay[streams[i]])) {
            channelInfo.live_url = channelInfo.fast_play[streams[i]].video_url;
          } else {
            channelInfo.live_url = channelInfo.fast_play[streams[i]];
          }
          channelInfo.updated_live_url = true; // <- Marca/flag para optimizar siguientes playings de este canal, por fast playing
          break;
        }
      }
      ChannelStreamUtil.set(channelInfo);
    }
  }

  static changeLiveURL(Streams, fastPlayStreams, gid) {
    let channelInfo = ChannelStreamUtil.get(gid);
    for (let i = 0; i < Streams.length; i++) {
      console.log("have", Object.keys(fastPlayStreams), Streams[i]);
      if (Object.keys(fastPlayStreams).indexOf(Streams[i]) !== -1) {
        if (Utils.isObject(fastPlayStreams[Streams[i]])) {
          channelInfo.live_url = fastPlayStreams[Streams[i]].video_url;
        } else {
          channelInfo.live_url = fastPlayStreams[Streams[i]];
        }
        break;
      }
    }
    ChannelStreamUtil.set(channelInfo);
    console.log("channelInfo", ChannelStreamUtil.get(gid));
  }

  static getChannelLiveUrl(gid) {
    const cachedChannelData = Utils.getLiveStreamURL(gid);
    if (cachedChannelData && cachedChannelData.live_url) {
      return cachedChannelData.live_url;
    }

    return null;
  }

  static getLiveStreamURL(gid) {
    const channelInfo = ChannelStreamUtil.get(gid);
    if (channelInfo) {
      return channelInfo;
    }

    return null;
  }

  static getImageFrame(image, time) {
    let frameImage = null;
    let time_progress = time;
    time_progress = time_progress.replace(":", "h-").replace(":", "m-");
    frameImage = image.replace("00h-00m-00", time_progress);
    return frameImage;
  }

  static getByDeviceApaTimeSubtitle(device) {
    let result = 0;
    const data = Metadata.get("TimeSubtitleDevice", '{"default":0}');
    if (Utils.isJson(data)) {
      let tmp = JSON.parse(data);
      result = tmp[device] ? tmp[device] : tmp["default"];
    } else {
      result = 0;
    }
    return result;
  }

  static getApaSupportedStream(device, isTv = null, groupId = null, islive = false) {
    if (Utils.isFunction(Device.getDevice().getSubplatform)) {
      const subplatform = Device.getDevice().getSubplatform();

      if (subplatform !== undefined) {
        device = subplatform;
      }
    }
    // Usar UDP?, sólo aplica a live TV*

    let useUdp = false;
    // udp support a true por defecto
    let udp_support_config = Metadata.get(
      "udp_support_config",
      '{ "enable": true }'
    );
    udp_support_config = JSON.parse(udp_support_config);
    useUdp = udp_support_config && udp_support_config.enable ? true : false;

    // Termina resolve si se usa o no UDP, abajo se filtran los streamTypes
    /**
     * NOTA: para el caso de npvr no es necesario más de un tipo de streaming para playing de npvr
     * sólo se considera uno, el de la posición 0, por ej. > npvr: ['hls']
     *
     */

    let streams = this.getFallBackMetadata();
    streams = this.getStreamTypeName(streams);

    try {
      if (streams) {
        let combineStreams = null;
        if (isTv === true && !isNaN(groupId)) {
          // Streams disponibles para el groupid de acuerdo al common largo, si es que existen
          const _groupIdStreams = ChannelStreamUtil.get(groupId);
          if (
            _groupIdStreams &&
            _groupIdStreams.encodes &&
            Utils.isArray(_groupIdStreams.encodes)
          ) {
            const groupIdStreams = _groupIdStreams.encodes;
            // streams[device]['live'] es una estructura definida desde metadata
            combineStreams = Utils.combineLiveStreamType(
              streams["live"],
              groupIdStreams
            );
            // Si se usa udp ok, se deja pasar el array de strems combinados...pero
            // si no, entonces se quita udp de los soportados, no importando
            // que venga o udp por APA o udp por epg/channel
            if (!useUdp) {
              const newCombineStreams = combineStreams.filter(
                (streamType) => streamType !== playerConstant.IP_MULTICAST_UDP
              );
              combineStreams = newCombineStreams;
            }
          } else {
            // Si no vienen stream types desde epg/channel, se filtra metadata supported_streams
            if (!useUdp) {
              const newCombineStreams = streams["live"].filter(
                (streamType) => streamType !== playerConstant.IP_MULTICAST_UDP
              );
              streams["live"] = newCombineStreams;
            }
          }

          if (Utils.isArray(combineStreams) && combineStreams.length > 0) {
            // Reemplazar live de metadata con los nuevos streamTypes
            // sólo aplica live
            streams["live"] = combineStreams;
          }
          console.log("_groupIdStreams", _groupIdStreams);
          if (_groupIdStreams && _groupIdStreams.fast_play) {
            console.log("fast_play", _groupIdStreams.fast_play);
            Utils.changeLiveURL(
              streams["live"],
              _groupIdStreams.fast_play,
              groupId
            );
          }
        }

        return streams;
      }
    } catch (e) {
      console.error(
        "*** Error al obtener llave supported_stream de Metadata.",
        e
      );
      return null;
    }

    return null;
  }

  static getAPARegionalized(Apakey, param, defaultValue) {
    let apaValue = Metadata.get(Apakey, "{}");
    const region = storage.getItem("region");

    try {
      apaValue = JSON.parse(apaValue);

      if (apaValue) {
        apaValue = apaValue[region] || apaValue["default"];
      }

      if (apaValue && apaValue[param]) {
        return apaValue[param] || defaultValue;
      }
      if (apaValue && apaValue["default"]) {
        return apaValue["default"];
      }
    } catch (e) {
      console.log(">>> Error", e);
      return defaultValue || null;
    }
    return defaultValue || null;
  }

  //Devuelve el valor de una llave de metadata
  static getApaMetadataKey(apakey, defaultValue, property) {
    let metadataValue = null;

    try {
      metadataValue = JSON.parse(Metadata.get(apakey, defaultValue));
    }
    catch (ex) {
      console.error('Error tring parse metadata JSON', ex);

      return defaultValue;
    }
    if (property && metadataValue) {
      const { [property]: returnValue } = metadataValue;
      if (returnValue === undefined) {
        if (metadataValue['default']) {
          if (metadataValue['default'][property]) {
            return metadataValue['default'][property];
          }
        }
      }
      return returnValue;
    }
    return metadataValue;

  }

  static isColorInPlayerControlEnable(colorCode) {
    const colorButton = colorCode + "button";
    const isColorEnable = this.getApaMetadataKey('playercontrols', {}, colorButton);

    return isColorEnable && isColorEnable.enable && isColorEnable.enable === true;
  }

  static findNode(node, index, array, code, extra2) {
    console.log("+>+ findNode, node:", node);
    console.log("+>+ findNode, index:", index);
    console.log("+>+ findNode, array: ", array);
    console.log("+>+ findNode, extra1:", code);
    console.log("+>+ findNode, extra2:", extra2);

    if (node.code === code) {
      this.currentNode = node;
    } else if (node.childs && node.childs.forEach) {
      node.childs.forEach(this.findNode);
    }
  }

  /**
   * Para DEBUG, remueve las propiedades del tipo "function" en js objetos (sólo js objetos planos, se verifica functions sólo en el "primer nivel")
   */
  static removeFunctionProperty(plainObject) {
    if (!Utils.isObject(plainObject)) return null;
    const tempObject = Object.assign({}, plainObject);

    for (const i in tempObject) {
      if (Utils.isFunction(tempObject[i])) {
        delete tempObject[i];
      }
    }

    return tempObject;
  }

  static getIntervalTimeCheckEpgVersion() {
    const region = storage.getItem("region");
    let updateType = Metadata.get(
      "interval_time_check_epg_version",
      '{"default":"5"}'
    );
    updateType = JSON.parse(updateType);
    return updateType[region] || updateType["default"];
  }

  static getIntervalTimeCheckLinealChannels() {
    const region = storage.getItem("region");
    let updateType = Metadata.get(
      "interval_time_check_lineal_channels",
      '{"default":"60"}'
    );
    updateType = JSON.parse(updateType);
    return updateType[region] || updateType["default"];
  }

  static getIntervalTimeCheckPostpone() {
    const region = storage.getItem("region");
    // Minutos en las que se lanzara de nuevo el modal.
    let updateType = Metadata.get(
      "interval_time_check_postpone",
      '{"default":"60"}'
    );
    updateType = JSON.parse(updateType);
    return updateType[region] || updateType["default"];
  }

  static appVersionToNumber(version) {
    const arrayVersion = version.split(".");
    if (arrayVersion.length > 0)
      return parseInt(
        arrayVersion.reduce((previous, current) => previous.concat(current))
      );
    else return null;
  }

  // a app_version from API, b app_version from localStorage
  static compareVersions(a, b) {
    console.log(
      "[Utils] [EpgVersionStatus] compareVersions a(app_version from API), b(app_version from localStorage)",
      a,
      b
    );
    if (a === b || !a || !b) {
      return false;
    }
    const a_components = a.split(".");
    const b_components = b.split(".");
    const length_a_components = a_components.length;
    const length_b_components = b_components.length;
    if (length_a_components === length_b_components) {
      for (let i = 0; i < length_a_components; i++) {
        if (parseInt(a_components[i]) > parseInt(b_components[i])) {
          return true;
        }
        if (parseInt(a_components[i]) < parseInt(b_components[i])) {
          return false;
        }
      }
    }
    return false;
  }

  //metadata key to toggle function in order to show the talent ribbon in vcard
  static getToggleFunctionsFromMetadata() {
    const region = storage.getItem("region");
    let toggleFunctions = Metadata.get(
      "toggle_functions_",
      DefaultToggleFunctions
    );
    toggleFunctions = JSON.parse(toggleFunctions);
    return toggleFunctions[region] || toggleFunctions["default"];
  }

  static getCoverFlowVisibilityFromMetadata() {
    const region = storage.getItem("region");
    const defaultCoverFlowVisibility = '{"default":{"enable":false}}';
    let coverFlowVisibility = Metadata.get(
      "cover_flow_visibility",
      defaultCoverFlowVisibility
    );
    coverFlowVisibility = JSON.parse(coverFlowVisibility);
    return coverFlowVisibility[region] || coverFlowVisibility["default"];
  }

  static seekInPause(callback, seek) {
    const platf = Device.getDevice().getSubplatform();
    if (platf !== "stbcoship") {
      callback(seek);
    } else {
      setTimeout(() => {
        callback(seek);
      }, 1000);
    }
  }

  static keyBloquedInPTV(pathname, key) {
    let keyBloked = {
      RED: 118, // F7
      GREEN: 119, // F8
      YELLOW: 120, // F9
      BLUE: 121, // F10
      BACK: 8,
      MOSAIC: 77, // m
      GUIDE: 78, // n
      FAV: 70, // f
      PREV: 69, // e
      HD: 72, //h,
      VOD: 88, //x
      INFO: 457,
      PPV: 133,
    };

    if (pathname.includes("ptv") && keyBloked[key]) {
      return true;
    }
    return false;
  }

  static scriptCyberSource() {
    const defaultCyberConfig =
      '{ "org_id":"1snn5n9w", "merchant_id":"decompras_clarovideomx", "custom_profiling_domain":"https://h.online-metrix.net/fp/tags.js"}';
    const cyberConfig = Utils.getApaMetadataKey("cybersource_configuration", defaultCyberConfig);
    const hks = storage.getItem("HKS", "");
    const time = new Date().toTimeString().split(" ")[0];
    if (!this.isEmpty(cyberConfig)) {
      const sessionId = cyberConfig.merchant_id + hks + time;
      const url =
        cyberConfig.custom_profiling_domain +
        "?org_id=" +
        cyberConfig.org_id +
        "&session_id=" +
        sessionId;
      this.loadScript(url);
    }
  }

  static getDelayByChdownup() {
    let intval = 500;
    const region = storage.getItem("region");
    let choice = Metadata.get(
      "channel_down_up",
      '{"default":{"enable":true, "delay_after_updown": 500}}'
    );
    choice = JSON.parse(choice);
    if (!Utils.isEmpty(choice)) {
      intval = choice[region]
        ? choice[region].delay_after_updown
        : choice["default"].delay_after_updown;
    }
    return intval;
  }
  static isModalEpgVersionOpen() {
    return !this.isModalHide() && this.modalFrom() === "epgVersionStatus";
  }

  static isModalEpgLive() {
    const { modal: { modalType = null } = {} } = store.getState();
    return !this.isModalHide() && modalType && (modalType === MODAL_FILTERS_LIVE_CATEGORIES || modalType === MODAL_FILTERS_LIVE);
  }

  static isAkamaiEnable() {
    return this.getApaMetadataKey('akamai_analytics_config', '{"enable":false}', 'enable');
  }

  static choiceBehaviorChannelChange() {
    let enableChannelDownUp = false;
    const region = storage.getItem("region");
    let choice = Metadata.get("channel_down_up", '{"default":{"enable":true}}');
    choice = JSON.parse(choice);
    if (!Utils.isEmpty(choice)) {
      enableChannelDownUp = choice[region]
        ? choice[region].enable
        : choice["default"].enable;
    }
    return enableChannelDownUp;
  }

  static checkIfEmailInString(text) {
    const re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
    return re.test(text);
  }

  static extractEmails(text) {
    return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
  }

  static isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  static getMaxLengthMovil() {
    switch (storage.getItem("region")) {
      case "argentina":
        return 11;
      case "mexico":
        return 10;
      default:
        return 15;
    }
  }

  static getErrorToInput(code) {
    const objWithError = {};
    const defaulErrorInput = '{"otp":["WRONG_OTP","INVALID_OTP"],"msisdn":["NO_AMX_MSISDN"],"email":["user_email_invalido","userexist"],"password":["user_login_invalido"]}';
    const errorsInput = this.getApaMetadataKey('sso_placeholder_errors', defaulErrorInput);

    !this.isEmpty(errorsInput) &&
      code &&
      Object.keys(errorsInput).map((typeError) => {
        this.isArray(errorsInput[typeError]) &&
          errorsInput[typeError].map((error) => {
            if (error.trim() === code) {
              console.log("getErrorToInput", error, code, typeError);
              objWithError[typeError] = error;
            }
          });
      });
    return objWithError;
  }

  static behaviorOfError(error, callbackExist, callbackModal, propsModal) {
    console.error("behaviorOfError", error);
    const errorToInput = this.getErrorToInput(error.code);

    let errorsTohandle = [];

    if (errorToInput && !Utils.isEmpty(errorToInput)) {
      const key = Object.keys(errorToInput)[0];
      errorsTohandle[key] = Translator.get(errorToInput[key], error.message);

      if (
        Object.keys(errorsTohandle).length &&
        this.isFunction(callbackExist)
      ) {
        return callbackExist(errorsTohandle);
      }
    }
    return this.isFunction(callbackModal)
      ? callbackModal(AAF_MODAL_ERROR, error, propsModal)
      : false;
  }

  static isPTV(user) {
    return user.isIptv || false;
  }

  static eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent("on" + etype);
    } else {
      var evObj = document.createEvent("Events");
      evObj.initEvent(etype, true, false);
      el.dispatchEvent(evObj);
    }
  }

  static encodeParams(data) {
    let parameters = {};
    const keys = Object.keys(data);
    keys.map((key) => {
      parameters[key] = encodeURIComponent(data[key]);
    });
    return parameters;
  }

  static moveSpatial(currentKey) {
    const direcction = {
      CH_UP: "down",
      CH_DOWN: "up",
    };
    window.SpatialNavigation.move(direcction[currentKey]);
  }

  static canMoveFocus(key) {
    let move = true;
    const keysNotMove = ["CH_UP", "CH_DOWN"];
    const listKeys = Device.getDevice().getKeys();
    keysNotMove.map((value) => {
      if (
        listKeys &&
        listKeys.valueKeyMap &&
        value === listKeys.valueKeyMap[key] &&
        !this.isMiniEPGOpen()
      ) {
        move = false;
      }
    });
    console.log("canMoveFocus", key, move);
    return move;
  }

  static isPipAvailable() {
    let result;
    const device = Device.getDevice().getPlatform();
    const data = Metadata.get("pip_available", '{"default":true,"arris":false}');
    if (Utils.isJson(data)) {
      let tmp = JSON.parse(data);
      result =
        typeof tmp[device] !== "undefined" ? tmp[device] : tmp["default"];
    } else {
      result = true;
    }
    return result;
  }

  static hideSkipIntro() {
    let skipIntroElement = document.getElementsByClassName(
      "player-ui-container-skip"
    );
    if (
      skipIntroElement &&
      skipIntroElement[0] &&
      skipIntroElement[0].classList &&
      typeof skipIntroElement[0].classList.remove === "function"
    ) {
      skipIntroElement[0].classList.remove("show-skip-intro");
    }
  }

  /**
   * OJO aquí: Esta llave de animaciones NO es regionalizada, sólo por device.
   * Así que esa llave no esra agregada en el middleware (keys x región)
   * @returns
   */
  static playerEnableAnimation() {
    // Ejemplo de la llave
    // "player_enable_animations": "{\"enable\":false}",

    // let subplatform = null;
    // if (Utils.isFunction(Device.getDevice().getSubplatform)) {
    //   subplatform = Device.getDevice().getSubplatform();
    // }
    // let platform = Device.getDevice().getPlatform();
    // if(subplatform === 'zte' || platform === 'tizen') {
    //   return true;
    // }

    // return false;

    /*
    Hardcodeado,
    */


    return Utils.getApaMetadataKey("player_enable_animations", '{"enable":false}', 'enable');
  }

  static fieldfill(value, number, length) {
    var result = number.toString();
    var pad = length - result.length;
    while (pad > 0) {
      result = value + result;
      pad--;
    }
    return result;
  }

  static isTimeoutAvailable() {
    let result;
    const region = storage.getItem("region");
    const data = Metadata.get("timeout_available", '{"default":false}');
    if (Utils.isJson(data)) {
      let tmp = JSON.parse(data);
      result =
        typeof tmp[region] !== "undefined" ? tmp[region] : tmp["default"];
    } else {
      result = false;
    }
    return result;
  }

  static isCurrent(event) {
    const { date_begin, date_end } = event;
    const isCurrentEvent = this.isDateBetween(date_begin, date_end);
    return isCurrentEvent;
  }

  static idEventCurrent(epg, index) {
    let elements = document.getElementsByClassName("epg-event-item-container");
    elements = Array.from(elements);

    let currentEventId = false;
    elements.length > 0 &&
      elements.map((eventDiv) => {
        const channelId = eventDiv.getAttribute("data-channel-id");
        const eventId = eventDiv.getAttribute("data-event-id");

        let channel =
          epg &&
          epg.data &&
          epg.data.find((channel) => {
            channel = channel.reduce((channel) => channel);
            return channel.id === channelId;
          });

        const event =
          channel &&
          channel[0] &&
          channel[0].events[index] &&
          channel[0].events[index].find((event) => event.id === eventId);

        if (event && this.isCurrent(event)) {
          currentEventId = eventId;
        }
      });
    return currentEventId ? `#event-${currentEventId}-${0}` : currentEventId;
  }

  static arraysMatch(arr1, arr2) {
    if (
      !Array.isArray(arr1) ||
      !Array.isArray(arr2) ||
      arr1.length !== arr2.length
    )
      return false;
    // Check if the arrays are the same lengt
    // Check if all items exist and are in the same order
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    // Otherwise, return true
    return true;
  }

  static subtractionArrays(arr1, arr2) {
    console.log("subtractionArrays arr1, arr2", arr1, arr2);
    if (!Array.isArray(arr1) || !Array.isArray(arr2)) return [];
    for (let i = 0; i < arr2.length; i++) {
      arr1 = arr1.filter((it) => it !== arr2[i]);
    }
    return arr1;
  }

  static addHour(d, h) {
    if (d) {
      const date = new Date(d);
      return date.setTime(date.getTime() + h * 60 * 60 * 1000);
    }
  }

  static msToTime(duration) {
    try {
      let seconds = parseInt((duration / 1000) % 60);
      let minutes = parseInt((duration / (1000 * 60)) % 60);
      let hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      return (
        (hours > 0 ? hours + "hs " : "") +
        (minutes > 0 ? minutes + "mins " : "") +
        (seconds > 0 ? seconds + "segs" : "")
      );
    } catch (error) {
      return "";
    }
  }

  static addMinutes = function (d, m) {
    if (d) {
      const date = new Date(d);
      return new Date(date.getTime() + m * 60000);
    }
  };

  static getEPGDateToString(date) {
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const hour = ("0" + date.getHours()).slice(-2);
    const minute = ("0" + date.getMinutes()).slice(-2);

    return `${day}/${month} ${hour}:${minute} hs.`;
  }

  /**
   * Capitalize a string.
   *
   * @example
   * console.log(Utils.capitalize("some name")); // -> Some name
   *
   * @param {string} string String to capitalize
   * @return {string} Capitalized string
   */
  static capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1, string.length);
  }

  //metadata key to toggle feature to show or not promo banner in resume when PBI is null
  static getShowPromoBannerInCard() {
    try {
      const region = storage.getItem("region");
      let toggleFunctions = Metadata.get(
        "show_promo_banner_in_card",
        '{"argentina":{"enable":true},"default":{"enable":false}}'
      );
      toggleFunctions = JSON.parse(toggleFunctions);
      return toggleFunctions[region] || toggleFunctions.default;
    } catch (e) {
      return { enable: false };
    }
  }

  static getShowHelperButtonsMiniEpg() {
    try {
      return this.getApaMetadataKey('show_helper_buttons_mini_epg',
        '{"enable":true}')
    } catch (e) {
      return { enable: true };
    }
  }

  static getLiveBarBackgroundColor() {
    try {
      const region = storage.getItem("region");
      let metadata = Metadata.get(
        "live_bar_background_color",
        '{"colombia":{"backgroundColor":"#CECECE"},"default":{"backgroundColor":"#25A4DA"}}'
      );
      metadata = JSON.parse(metadata);
      return metadata[region] || metadata.default;
    } catch (e) {
      return { backgroundColor: "#25A4DA" };
    }
  }

  static getListButtonToggle() {
    try {
      const region = storage.getItem("region");
      let metadata = Metadata.get(
        "list_button_toggle",
        '{"colombia":{"enable":false},"argentina":{"enable":true},"default":{"enable":true, "path":"/user-settings/idioma","path_not_npvr":"/user-settings/idioma"}}'
      );
      metadata = JSON.parse(metadata);
      return metadata[region] || metadata.default;
    } catch (e) {
      return { enable: true };
    }
  }

  static getPlayPauseButtonToggle() {
    try {
      const region = storage.getItem("region");
      let metadata = Metadata.get(
        "play_pause_button_toggle",
        '{"colombia":{"enable":true},"argentina":{"enable":false},"default":{"enable":false}}'
      );
      metadata = JSON.parse(metadata);
      return metadata[region] || metadata.default;
    } catch (e) {
      return { enable: false };
    }
  }

  static isAkamaiMfwkinLauncher(response) {
    let resp = false;
    if (
      response &&
      typeof response === "object" &&
      response.hasOwnProperty("akamai_mfwk")
    ) {
      resp = true;
    }
    return resp;
  }

  static closeArrisSession() {
    const params = {};
    const task = new GeneralTask(
      "http://session/management/exit",
      params,
      null,
      "POST"
    );
    const promiseGeneralTask = RequestManager.addRequest(task);
  }

  static hasApiRetry(url) {
    return !url.includes(UtilsClaroPagos.getServerUrl());
  }


  static mapToLineUp(channels = []) {
    const response = [];
    if (channels && Array.isArray(channels)) {
      channels.forEach((channel) => {
        const item = channel.group && channel.group.common || {};
        // SAME MW
        if (item) {
          item.id = channel.number;
          item.group_id = channel.group_id;
          item.channel_number = channel.number;
          item.proveedor =
            channel.group &&
            channel.group.common &&
            channel.group.common.extendedcommon &&
            channel.group.common.extendedcommon.media &&
            channel.group.common.extendedcommon.media.proveedor;
          item.cover = channel.group.common.image_small;
          item.imageEpg = channel.image;
          item.subtitle =
            channel.group &&
              channel.group.common &&
              channel.group.common.extendedcommon &&
              channel.group.common.extendedcommon.media &&
              channel.group.common.extendedcommon.media.language &&
              channel.group.common.extendedcommon.media.language.subtitle &&
              channel.group.common.extendedcommon.media.language.subtitle ? channel.group.common.extendedcommon.media.language.subtitle : null;
          item.audio =
            channel.group &&
              channel.group.common &&
              channel.group.common.extendedcommon &&
              channel.group.common.extendedcommon.media &&
              channel.group.common.extendedcommon.media.language &&
              channel.group.common.extendedcommon.media.language.audio &&
              channel.group.common.extendedcommon.media.language.audio ? channel.group.common.extendedcommon.media.language.audio : null;
          item.format_types = channel.group.common.extendedcommon.format.types.split(',');
          item.href = '';
          item.image_still = channel.group.common.image_small;
          item.portrait = channel.group.common.image_medium;
          item.provider = 'default';
          item.type = 'live';
          item.year = null;
          item.live_enabled = '1';
          item.rating = channel.group.common.extendedcommon.media.rating.code;
          // TODO: el de abajo es para agregar el id
          item.rating_id = channel.group.common.extendedcommon.media.rating.id;
          item.timeshift = Math.floor(parseInt(channel.group.common.extendedcommon.media.timeshift, 10) / 60);
          item.adUrl = null;
          item.ads = null;
          item.channel_url = null;
          item.encodes = [];
          item.fast_play = null;
          if (
            channel.group &&
            channel.group.common &&
            channel.group.common.extendedcommon &&
            channel.group.common.extendedcommon.media &&
            channel.group.common.extendedcommon.media.language &&
            channel.group.common.extendedcommon.media.language.options &&
            channel.group.common.extendedcommon.media.language.options.option &&
            channel.group.common.extendedcommon.media.language.options.option[0]
          ) {
            item.encodes = channel.group.common.extendedcommon.media.language.options.option[0].encodes;
            item.fast_play = channel.group.common.extendedcommon.media.language.options.option[0].fast_play;
            delete channel.group.common.extendedcommon;
          }
          item.live_url = null;
          if (channel.epg_url) {
            item.live_url = channel.epg_url;
          }
          item.background = channel.group && channel.group.common && channel.group.common.image_background || '';
          response.push(item);
        }
      });
    }
    return response;
  }

  static hasAValidVodURL() {
    const currentURL = window.location.href;
    let response = true;
    if (currentURL.includes("search")) {
      response = false;
    }
    return response;
  }

  static mapTracksTodoPGMAlbum(tracks, respTracks) {
    const respArray =
      respTracks &&
        respTracks.response &&
        respTracks.response.components &&
        respTracks.response.components[0] &&
        respTracks.response.components[0].properties &&
        respTracks.response.components[0].properties.medias
        ? respTracks.response.components[0].properties.medias
        : null;
    if (tracks && Array.isArray(tracks) && respArray && Array.isArray(respArray)) {
      for (const x in tracks) {
        for (const y in respArray) {
          if (tracks[x].id && respArray[y].id && respArray[y].id === tracks[x].id) {
            if (respArray[y].media && respArray[y].media.track_url) {
              tracks[x].url = respArray[y].media.track_url;
              tracks[x].tracking = respArray[y].tracking ? respArray[y].tracking : {};
              break;
            }
          }
        }
      }
    }
    return tracks;
  }

  static mapEventToEpgPersistance(event, group_id) {
    return {
      channel_id: event.channel_id || null,
      date_begin: parseInt(event.unix_begin) || null,
      date_end: parseInt(event.unix_end) || null,
      description: event.description || '',
      duration: event.duration || '',
      dvb_content: event.dvb_content || '',
      ext_catchup: event.ext_catchup || null,
      ext_episode_id: event.ext_episode_id || null,
      ext_eventimage_name: event.ext_eventimage_name || '',
      ext_recordable: event.ext_recordable || null,
      ext_season_id: event.ext_season_id || null,
      ext_series_id: event.ext_series_id || null,
      ext_startover: event.ext_startover || null,
      ext_year: event.ext_year || null,
      group_id: group_id,
      id: event.id || null,
      event_alf_id: event.event_alf_id || null,
      id_composite: `${group_id}${event.event_alf_id || event.id}` || '',
      name: event.name || '',
      // nextEventId: "757554655"
      parental_rating: event.parental_rating || null,
      // previousEventId: "757554649"
      // recording_id: ""
      recording_status: event.ext_recordable === '1' ? 1 : 0,
      type: event.type || null
    }
  }



  static gatNavigatorInfo() {
    navigator.sayswho = (function () {
      var ua = navigator.userAgent;
      var tem;
      var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(' ');
    })();
    return navigator.sayswho;
  }

  static addPageAction(eventName){
    if(window && window.newrelic && Utils.isFunction(window.newrelic.addPageAction)) {
      window.newrelic.addPageAction(eventName);
    }
  }

  static setCustomAttribute() {
    const { device_id, device_category, device_manufacturer, device_model, device_type } = getAppConfig();
    const { user } = store.getState();

    if (user.isLoggedIn && user.isLoggedIn) {
      if (window && window.newrelic && Utils.isFunction(window.newrelic.setCustomAttribute)) {
        window.newrelic.setCustomAttribute('username', user.isLoggedIn ? user.username : null)
        window.newrelic.setCustomAttribute('user_id', user.isLoggedIn ? user.user_id : null)
        window.newrelic.setCustomAttribute('region', storage.getItem('region'))
        window.newrelic.setCustomAttribute('HKS', storage.getItem('HKS'))
        window.newrelic.setCustomAttribute('device_id', device_id)
        window.newrelic.setCustomAttribute('device_category', device_category)
        window.newrelic.setCustomAttribute('device_manufacturer', device_manufacturer)
        window.newrelic.setCustomAttribute('device_model', device_model)
        window.newrelic.setCustomAttribute('device_type', device_type)
      }
    }
  }

  static cleanCustomAttribute() {
    if (window && window.newrelic && Utils.isFunction(window.newrelic.setCustomAttribute)) {
      window.newrelic.setCustomAttribute('username', null)
      window.newrelic.setCustomAttribute('user_id', null)
      window.newrelic.setCustomAttribute('region', null)
      window.newrelic.setCustomAttribute('HKS', null)
      window.newrelic.setCustomAttribute('device_id', null)
      window.newrelic.setCustomAttribute('device_category', null)
      window.newrelic.setCustomAttribute('device_manufacturer', null)
      window.newrelic.setCustomAttribute('device_model', null)
      window.newrelic.setCustomAttribute('device_type', null)
    }
  }
  static showModalError(isModalReintento, pgm = {}) {
    const state = store.getState();
    const { playerstate, islive } = state.player;
    const {
      entry: {
        device_type = ''
      } = {},
      errors = []
    } = pgm || {}
    const [firstError = {}] = errors;
    const { code: errorCode = '' } = firstError;
    const simultaneousStreamingErrorCodes = Utils.getApaMetadataKey('simultaneous_streaming_error_codes', '{"default":{"codes":["PLY_CSS_00001"]}}', "codes");
    const isIPTVByDeviceType = device_type && device_type.toLowerCase() === 'ptv';
    const isSimultaneousStreamingError = simultaneousStreamingErrorCodes.includes(errorCode);
    if (isModalReintento) {
      // Si ott mostrar error
      if (playerstate === AAFPLAYER_PLAY && islive && !isIPTVByDeviceType) {
        return true;
      }
      // Si es iptv no se muestra modal
      else if (playerstate === AAFPLAYER_PLAY && islive && isIPTVByDeviceType) {
        return false;
      }
      // Default muestra el error en ott y no en iptv
      else {
        return isIPTVByDeviceType ? false : true;
      }
    }
    else {
      return playerstate === AAFPLAYER_PLAY && islive ? false : true;
    }
  }

  static isInSearchPage() {
    return window.location.href.indexOf('/search') > -1;
  }
  static setIsFromSearch(value) {
    AAFData.set('isFromSearch', value)
  }
  static getIsFromSearch() {
    return AAFData.get('isFromSearch');
  }

  static setTitleSerie(result) {
    const { response: { title = '' } = {} } = result || {};
    AAFData.set('serieTitle', title)
  }

  static getTitleSerie(value) {
    return AAFData.get('serieTitle', value)
  }

  static setLastRibbonName(value) {
    return AAFData.set('lastRibbonName', value)
  }

  static getLastRibbonName(value) {
    return AAFData.get('lastRibbonName')
  }

  static setMaxRibbonMarginTop(value) {
    return AAFData.set('maxRibbonMarginTop', value)
  }

  static getMaxRibbonMarginTop() {
    return AAFData.get('maxRibbonMarginTop')
  }

  static getJsonYouboraToggle(youbora_toggle) {
    const region = storage.getItem('region');
    if (region) {
      return youbora_toggle[region]
        ? youbora_toggle[region]
        : youbora_toggle['default'];
    } else {
      return youbora_toggle['default'];
    }
  }

  static getOjectYouboraToggle() {
    const default_Youbora_Toggle = `{"vod": true,"live": true,"startover": true,"catchup": true,"npvr": true}`;
    const youbora_toggle = this.getApaMetadataKey("youbora_toggle_monitor", default_Youbora_Toggle);

    return youbora_toggle;
  }

  static getDelayFinPlayerSeries() {
    const delayFinplayerSeries = Utils.getApaMetadataKey('endplayer_config', '{"default": {"duration": 5}}');
    return delayFinplayerSeries.default.duration;
  }

  static sendMetric = (props, action, label, componet) => {
    if (typeof props.setMetricsEvent === 'function') {
      props.setMetricsEvent({
        hitType: 'event',
        eventCategory: componet,
        eventAction: action,
        eventLabel: label
      });
      props.setMetricsEvent({ type: 'executor' });
      Utils.sendDimension(props);
    }
  };

  static sendDimension(props) {
    const payload = new AnalyticsDimensionSingleton().getPayload();
    props.setMetricsEvent(payload);
    props.setMetricsEvent({ type: 'executor' });
  }

  static getStatusYouboraToggle(contentStreamType) {
    let ActiveYouboraToggle = this.getOjectYouboraToggle();
    let isActiveYouboraToggle = false;
    switch (contentStreamType) {
      case 'content_is_vod':
        isActiveYouboraToggle = ActiveYouboraToggle.vod;
        break;
      case 'content_is_tv':
        isActiveYouboraToggle = ActiveYouboraToggle.live;
        break;
      case 'content_is_startover':
        isActiveYouboraToggle = ActiveYouboraToggle.startover;
        break;
      case 'content_is_catchup':
        isActiveYouboraToggle = ActiveYouboraToggle.catchup;
        break;
      case 'content_is_npvr':
        isActiveYouboraToggle = ActiveYouboraToggle.npvr;
        break;
      default:
        isActiveYouboraToggle = false;
        break;
    }
    return isActiveYouboraToggle;
  }
  static setHasClaroMusicaNode(value) {
    AAFData.set('hasClaroMusicaNode', value)
  }
  static getHasClaroMusicaNode() {
    return AAFData.get('hasClaroMusicaNode');
  }

  static filterNavNodes(nodes = []) {
    const user = store.getState().user;
    const navVisibility = JSON.parse(Metadata.get('nav_visibility'));

    const filteredNodes = nodes.filter(node => {
      const isAnonymous = user.isAnonymous;
      const isSusc = user.isSusc;
      let shouldBeVisible = true;
      const match = navVisibility.find(nav => nav.code === node.code);
      if (match) {
        if (isAnonymous) {
          shouldBeVisible = !!match.anonymous;
          console.log('Match shouldBeVisible isAnonymous', shouldBeVisible);
        } else if (isSusc) {
          shouldBeVisible = !!match.susc;
          console.log('Match shouldBeVisible isSusc', shouldBeVisible);
        } else if (!isSusc) {
          shouldBeVisible = !!match.no_susc;
          console.log('Match shouldBeVisible !isSusc', shouldBeVisible);
        }
      }
      return shouldBeVisible;
    });
    return filteredNodes;
  }


  static getOnlyDigitsInString(str) {
    const num = str.replace(/[^0-9]/g, '');
    return parseInt(num, 10);
  }

  /**
   *
   * @param {string} element
   */
  static setInitialFocus(element) {
    setTimeout(() => {
      window.SpatialNavigation.focus(element);
    }, 100);
  }

  /**
   * Establece el enfoque inicial en el elemento pasado como primer argumento, después de un retraso de
   * 100 milisegundos.
   * @param element - El elemento en el que desea centrarse.
   * @param [timeValue=100] - El tiempo en milisegundos de espera antes de establecer el foco en el
   * elemento.
   */
  static setInitialFocusChangeTime(element, timeValue = 100) {
    setTimeout(() => {
      window.SpatialNavigation.focus(element);
    }, timeValue);
  }

  /**
 * Single element input
 * @param {Array} elements array of id's
 */
  static onFocusElement(elements) {
    elements.forEach(e => {
      if (document.activeElement.className.includes('aaf_keyboard')) {
        if (document.getElementById(e.id)) {
          document.getElementById(e.id).style.border = INPUT_STYLE_OUTFOCUS;
        }
      } else {
        if (document.getElementById(e.id)) {
          document.getElementById(e.id).style.border = '';
        }
      }
    });
  }

  static validateSoaEPG(params) {
    if (params.epg_version === 'false') {
      delete params.epg_version;
    }
    if (params.soa_version === 'false') {
      delete params.soa_version;
    }
    return params;
  }

  static launchResponse(flags) {
    let launch = true;

    for (let i = 0; i < flags.length; i++) {
      if (!flags[i].flag) {
        launch = false;
        break;
      }
    }

    return launch;
  }

  static limitCharacters(labelContent, maxForType) {
    switch (maxForType) {
      case BUTTON_CONTRATA:
        if (labelContent.length >= CHARACTERS_BUTTON_CONTRATA) {
          return this.getCharactersInString(labelContent, BUTTON_CONTRATA);
        }
        return labelContent;
      case BUTTON_INCLUDES:
        if (labelContent.length >= CHARACTERS_BUTTON_INCLUDES) {
          return this.getCharactersInString(labelContent, BUTTON_INCLUDES);
        }
        return labelContent;
      case LABEL_PROMOTION:
        if (labelContent.length >= CHARACTERS_LABEL_PROMOTION) {
          return this.getCharactersInString(labelContent, LABEL_PROMOTION);
        }
        return labelContent;
      case LABEL_TASK:
        if (labelContent.length >= CHARACTERS_LABEL_TASK) {
          return this.getCharactersInString(labelContent, LABEL_TASK);
        }
        return labelContent;
      case LABEL_PERIODICITY:
        if (labelContent.length >= CHARACTERS_LABEL_PERIODICITY) {
          return this.getCharactersInString(labelContent, LABEL_PERIODICITY);
        }
        return labelContent;
      case LABEL_PRICE:
        if (labelContent.length >= CHARACTERS_LABEL_PRICE) {
          return this.getCharactersInString(labelContent, LABEL_PRICE);
        }
        return labelContent;
      default:
        return labelContent;
    }
  }

  static getCharactersInString(labelContent, stringType) {
    let searchLength = '';

    switch (stringType) {
      case BUTTON_CONTRATA:
        searchLength = labelContent.substring(0, CHARACTERS_BUTTON_CONTRATA);

        return searchLength;
      case BUTTON_INCLUDES:
        searchLength = labelContent.substring(0, CHARACTERS_BUTTON_INCLUDES);

        return searchLength;
      case LABEL_PROMOTION:
        searchLength = labelContent.substring(0, CHARACTERS_LABEL_PROMOTION);

        return searchLength;
      case LABEL_TASK:
        searchLength = labelContent.substring(0, CHARACTERS_LABEL_TASK);

        return searchLength;
      case LABEL_PERIODICITY:
        searchLength = labelContent.substring(0, CHARACTERS_LABEL_PERIODICITY);

        return searchLength;
      case LABEL_PRICE:
        searchLength = labelContent.substring(0, CHARACTERS_LABEL_PRICE);

        return searchLength;
      default:
        return labelContent;
    }
  }

  static getDeviceID = () => {
    const deviceId = [];
    const device_config = Object.assign(Device.getDevice().getConfig(),  getAppConfig());
    deviceId.push(device_config.serial_id ? device_config.serial_id : device_config.device_id);
    deviceId.push(device_config && device_config.device_manufacturer ? device_config.device_manufacturer : '-' );
    return deviceId;
  }

  static getSupportStreamFBLive(supported_stream_types){
    const stream_types_fullBack = this.getFallBackMetadata();
    let arrStTv = [];
    const tvObj = stream_types_fullBack['live']

    for(let i = 0; i < tvObj.length; i++) {
      arrStTv.push(tvObj[i][0]);
    };

    if(arrStTv!== undefined && supported_stream_types && supported_stream_types.live){
      supported_stream_types.live = arrStTv;
      return supported_stream_types;
    }
  }
  static getTimerFallBackDevice(streamType = []){
    const stream_types_device = this.getFallBackMetadata();
    const timeStremType = stream_types_device.live.filter((key) => {
      if(key[0] === streamType ) return key[1];
    });
    return timeStremType.length > 0  ? timeStremType[0][1] : [];
  }

  static getFallBackMetadata(){
    const supported_stream_time_default =  '{"default": {"vod": ["dashwv_ma","dashwv"],"live": [["ip_multicast_lms",4],["ip_multicast_udp",10],["hls_kr",5],["dashwv",8]],"timeshift": ["hls","hls_kr"],"npvr": ["hls"],"catchup": ["hls","hls_kr"]},"argentina": {"vod": ["dashwv_ma","dashwv"],"live": [["ip_multicast_lms",4],["ip_multicast_udp",4],["hls_kr",4],["dashwv",4]],"timeshift": ["hls","hls_kr"],"npvr": ["hls"],"catchup": ["hls","hls_kr"]}}';
    let objectMeta = Metadata.get(SUPPORTEDSTREAMTYPE, supported_stream_time_default)
    objectMeta = JSON.parse(objectMeta);
    const _region = this.getRegion();
    const value = objectMeta[_region] ? objectMeta[_region] : objectMeta[DEFAULT];
    return value;
  }

  static getStreamTypeName(streams = []){
    if(streams && streams.live){
      streams[LIVE] = streams.live.map((key) => {
        return key[0];
      });
    }
    return streams;
  }

  static getRegion = function (){
    const region = storage.getItem(REGION);
    return region;
  }
  
  static getProviderFromPgm = function (pgm) {
    let provider = null;
    if (
      pgm && 
      pgm.data && 
      pgm.data.group && 
      pgm.data.group.common && 
      pgm.data.group.common.extendedcommon && 
      pgm.data.group.common.extendedcommon.media && 
      pgm.data.group.common.extendedcommon.media.proveedor && 
      pgm.data.group.common.extendedcommon.media.proveedor.codigo
    ) {
      provider = pgm.data.group.common.extendedcommon.media.proveedor.codigo;
    }
    return provider;
  }

  static isUnsupportedProvider = function (pgm) {
    const isUnsupportedDevice = this.isSTBKaon();
    const provider = this.getProviderFromPgm(pgm);
    const isUnsupportedProvider = provider && provider === 'hbov2';
    return isUnsupportedDevice && isUnsupportedProvider;
  }

}
export default Utils;

export function isNumber(char) {
  switch (char) {
    case 'ZERO':
    case 'ONE':
    case 'TWO':
    case 'THREE':
    case 'FOUR':
    case 'FIVE':
    case 'SIX':
    case 'SEVEN':
    case 'EIGHT':
    case 'NINE':
      return true;
    default:
      return false;
  }
}

export function setReloadMisContenidos(value) {
  AAFData.set('reloadMisContenidos', value)
}
export function getReloadMisContenidos() {
  return AAFData.get('reloadMisContenidos');
}

export function isSkipNoSuscriptionChannelEneable() {
  // ADR IPTV ARG
  // TODO: Se metera llave de metadata ????
  const { user: { type = OTT } = {} } = store.getState();

  if ((isAndroidDevice() && type === IPTV) || (type === OTT)) {
    return true;
  } else {
    return false;
  }
}

/**
 *
 * @param {string} element
 */
export function setInitialFocus(element, withDelay = true) {
  if (withDelay) {
    setTimeout(() => {
      window.SpatialNavigation.focus(element);
    }, 100);
  }
  else {
    window.SpatialNavigation.focus(element);
  }
}

/**
 * Single element input
 * @param {Array} elements array of id's
 */

export function onFocusElement(elements) {
  elements.forEach(e => {
    if (document.activeElement.className.includes('aaf_keyboard')) {
      if (document.getElementById(e.id)) {
        document.getElementById(e.id).style.border = '3px solid #4C6F94';
      }
    } else {
      if (document.getElementById(e.id)) {
        document.getElementById(e.id).style.border = '';
      }
    }
  });
}

/**
 * Multiple elements input
 * @param {Array} elements array objects of inputs
 */
export function onFocusMultipleElements(elements) {
  elements.forEach(e => {
    if (document.activeElement.className.includes('aaf_keyboard')) {
      if (document.getElementById(e.id) && e.activeElement) {
        document.getElementById(e.id).style.border = '3px solid #4C6F94';
      }
      if (document.getElementById(e.id) && !e.activeElement) {
        document.getElementById(e.id).style.border = '';
      }
    } else {
      if (document.getElementById(e.id)) {
        document.getElementById(e.id).style.border = '';
      }
    }
  });
}

export function onFocusMultipleElementsRC(elements, isFocusInput) {
  elements.forEach(e => {
    if (document.getElementById(e.id) && e.activeElement) {
      if (!isFocusInput) {
        document.getElementById(e.id).style.border = '3px solid #4C6F94';
      } else {
        const x = document.getElementById(e.id);
        window.SpatialNavigation.focus(x);
      }
    }
  });
}

/**
 *
 * @param {*} seconds
 * @returns milliseconds
 */
export function convertSecondsToMilliseconds(seconds) {
  let milliseconds = seconds * 1000;
  if (typeof seconds !== 'number') {
    milliseconds = Number(seconds) * 1000;
  }
  return milliseconds;
}

// Checa si el elemento es visible dentro de su contenedor (contenedor, debe, tiene height y overflow hidden en css/dom)
// id_parent es string, es el id del contenedor
// id_child es string, es el id del elemento que queremos ver si es visible en su contenedor
//
// Funciona para listas con childs que tienen misma altura, si se necesita childs
// de todos tamaños se debe meter un
// recursivo que recupere las alturas de los componentes o childs de childs
export function scrollIsElementVisible(id_parent, id_child) {

  const getOffset = function (element) {
    if (!element.getClientRects().length) {
      return { top: 0, left: 0 };
    }

    let rect = element.getBoundingClientRect();
    let win = element.ownerDocument.defaultView;
    return (
      {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      });
  };

  let x = 1;
  let y = 1;

  let jparent = document.getElementById(id_parent);
  let jchild = document.getElementById(id_child);

  if (!jparent || !jchild) {
    return false;
  }

  let ofss = getOffset(jparent);
  let viewport = {
    top: ofss.top,
    left: ofss.left
  };
  const jparentRect = jparent.getBoundingClientRect();
  viewport.right = viewport.left + jparentRect.width;
  viewport.bottom = viewport.top + jparentRect.height;

  let height = jchild.offsetHeight;
  let width = jchild.offsetWidth;

  if (!width || !height) {
    return false;
  }

  let bounds = getOffset(jchild);
  bounds.right = bounds.left + width;
  bounds.bottom = bounds.top + height;

  let visible = (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));

  if (!visible) {
    return false;
  }

  let deltas = {
    top: Math.min(1, (bounds.bottom - viewport.top) / height),
    bottom: Math.min(1, (viewport.bottom - bounds.top) / height),
    left: Math.min(1, (bounds.right - viewport.left) / width),
    right: Math.min(1, (viewport.right - bounds.left) / width)
  };

  return (deltas.left * deltas.right) >= x && (deltas.top * deltas.bottom) >= y;
}

export function setContainerHeight(showHeader, showBlueband) {
  const rootHeight = document.getElementById("root").clientHeight;
  const container = document.getElementById("container");
  let height = rootHeight;
  if (showHeader) {
    height = height - 91;
    if (showBlueband) {
      height = height - 71;
    }
  }
  if (!container) {
    setTimeout(() => {
      setContainerHeight(showHeader, showBlueband)
    }, 1000);
  } else {
    container.style.height = `${height}px`;
  }
}

export function getAuthdeviceConfig() {

  const apaConfigurationKey = 'authdevice_retry';
  const apaConfigurationDefault = JSON.stringify(
    {
      "async": 3,
      "timer_minutes": 10
    });

  return Utils.getApaMetadataKey(apaConfigurationKey, apaConfigurationDefault);

}

//* Funcion para obtener el valor de la llave enable_CMR_experience
export function getEnableCMRExperience() {
  const apaConfigurationKey = 'enable_CMR_experience';
  const apaConfigurationDefault = JSON.stringify(
    {
      "default": {
        "enable": false,
        "authdeviceCRM_interval": {
          "timer_hour": 24
        },
        "loginByToken_retry": {
          "async": 3,
          "timer_minutes": 10
        }
      }
    }
  );

  return Utils.getRegionaliazedMetadata(apaConfigurationKey, apaConfigurationDefault);
}

//* Funcion para data de Youbora
export function setYouboraData(email = '', region = '', device_id = '', sub_region = '') {
  window.youboraParams[4].value = email || '';
  window.youboraParams[8].value = region || '';
  window.youboraParams[10].value = device_id || '';
  window.youboraParams[15].value = sub_region || '';
}

export function shouldMetadataInfoShowed() {
  console.log(`%c NODE_ENV: ` + process.env.NODE_ENV, 'color:green')

  return true
  return process.env.NODE_ENV === 'development';

}

export function getOnboardingConfig() {
  return Utils.getRegionaliazedMetadata(
    'onboarding',
    '{"default":{"enable":false}}'
  );
}

/**
 *
 * @param {*} user response of AuthDevice API
 */
export function authdeviceInterceptor(user) {
  if (Utils.isPTV(user)) {
    storage.setItem("hadLoginSuccess", '1')
  }
}

/**
 *
 * @param {*} user response of Login API
 */
export function loginInterceptor(user) {
  if (getOnboardingConfig().enable) {
    storage.setItem("hadLoginSuccess", '1')
  }
}

function getUserType() {
  const { userStatus } = store.getState().user;
  return userStatus ? userStatus : null;
}

export function showSoccerWorldCup() {
  const showCarruselSoccerWorldCup = KEYQATAR2022DEFAULT;
  let _metadataValue = Metadata.get(QATAR2022ENABLED, showCarruselSoccerWorldCup)
  _metadataValue = JSON.parse(_metadataValue);

  const { enable, interval_time } = _metadataValue.default;
  const userStatus = getUserType();

  const enableAux = enable && userStatus ? enable[userStatus] : false;
  const metadataAux = { default: { enable: enableAux, interval_time } };

  return metadataAux.default;
}

export function getShowSoccerWorldCupNode(nodes) {
  const showSoccerWorldCupKey = showSoccerWorldCup();
  if (showSoccerWorldCupKey.enable) {
    return nodes;
  } else {
    return nodes.filter(node => (node.code !== MUNDIAL2022))
  }
}

export function getNavDataNodeByCode(codeValue) {
  const state = store.getState();
  const { navbar: { nodes = [] } = {} } = state;
  const findByCode = (nodes, code) => {
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (node.code === code) {
        return node
      } else if (node.childs && Array.isArray(node.childs)) {
        const result = findByCode(node.childs, code);
        if (result) {
          return result
        }
      }
    }
  }

  return findByCode(nodes, codeValue);

}

export function getNavDataNodeById(id) {
  const state = store.getState();
  const { navbar: { nodes = [] } = {} } = state;
  const findByCode = (nodes, id) => {
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i];
      if (node.id === id) {
        return node
      } else if (node.childs && Array.isArray(node.childs)) {
        const result = findByCode(node.childs, id);
        if (result) {
          return result
        }
      }
    }
  }

  return findByCode(nodes, id);

}

export function getContentAvailability(format_types, provider, isSerie, isEpisode, producttype) {
  if (producttype && producttype.includes && producttype.includes('EPISODEBUY')) return CONTENT_AVAILABILITY_BUY_EPISODE;
  if (producttype && producttype.includes && producttype.includes('SEASONBUY')) return CONTENT_AVAILABILITY_BUY_SEASON;
  if (producttype && producttype.includes && producttype.includes('RENT')) return CONTENT_AVAILABILITY_RENT;
  if (producttype && producttype.includes && producttype.includes('BUY')) return CONTENT_AVAILABILITY_BUY;
  if (format_types && format_types.includes) {
    if (format_types.includes('free')) return CONTENT_AVAILABILITY_FREE;
    if (format_types.includes('ppe')) return CONTENT_AVAILABILITY_RENT;
    if (format_types.includes('est')) return CONTENT_AVAILABILITY_BUY;
    if (format_types.includes('susc') && provider === 'default') return CONTENT_AVAILABILITY_SUBSCRIPTION;
    if (format_types.includes('susc') && provider !== 'default') return CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION;
  }
  if (isSerie) return CONTENT_AVAILABILITY_BUY_SEASON;
  if (isEpisode) return CONTENT_AVAILABILITY_BUY_EPISODE;
  return DOES_NOT_APPLY;
}

export function getContentCategory(isLive = false, isSerie = false, genders = [], isEpisode = false) {
  let isDocumentary = false;
  const DOCUMENTARY = 'documental';
  if (isLive) return CONTENT_TYPE_TV;
  if (isEpisode) return CONTENT_TYPE_SERIE;
  if (isSerie) return CONTENT_TYPE_SERIE;

  if (genders && Array.isArray(genders)) {
    isDocumentary = genders.some(element => {
      return element.toLowerCase() === DOCUMENTARY;
    });
    if (isDocumentary) return CONTENT_TYPE_DOCUMENTARY;
  } else {
    if (genders && genders.toLowerCase) {
      isDocumentary = genders.toLowerCase().includes(DOCUMENTARY);
    }
    if (isDocumentary) return CONTENT_TYPE_DOCUMENTARY;
  }
  return CONTENT_TYPE_MOVIE; //Default
}

export function getSeasonEpisodeInfo(isSerie = false, isEpisode = false, episode) {
  const { name = '', number = '', season = '' } = episode || {};
  if (isEpisode) {
    return `episodio ${number} ${name}`;
  } else if (isSerie) {
    return `temporada ${season}`;
  } else {
    return DOES_NOT_APPLY;
  }
}

export function getSuspendedAccountLabels() {
  const title = Translator.get('suspended_modal_title_label');
  const description = Translator.get('suspended_modal_description_label');
  const content = Translator.get('suspended_modal_scope_label');
  const footer = Translator.get('suspended_modal_number_callCenter_label');

  return {
    title,
    description,
    content,
    footer
  }
}
export function setRandomTimeout(callback, min, max, step) {
  const steps = Math.ceil((max - min) / step);
  const randomNumber = Math.floor(Math.random() * (steps - 1));
  const selectedValue = min + randomNumber * step;
  return setTimeout(callback, selectedValue);
}

export function getUserTypeGa4() {
  if (anonymous === getUserType()) return 'anonimo'
  return 'registrado'
}

export function dymamicHost(){
  const host = window.location.origin ? `${window.location.origin}/webapi-video/` :
               window.location.host ? `${window.location.protocol}//${window.location.host}/webapi-video/` : 
               `${window.location.protocol}//${window.location.hostname}/webapi-video/`;
  return host;
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js